import api from '../../lib/api';

export async function fetchFeatureData() {
  const fetchURL = 'features';
  return await api.get(fetchURL);
}
